export enum RequirementsEnum {
  NotifyRequirements = 'แจ้งความต้องการวัสดุ',
  historyRequirements = 'รายการความต้องการ',
  RequirementDetails = 'รายละเอียดความต้องการ',
  MaterialsList = 'รายการวัสดุ',
  ConsiderPurchase = 'พิจารณาจัดซื้อ',
  TrackStatus = 'ติดตามสถานะ',
  Type = 'ประเภท',
}

// แจ้งความต้องการ
export enum NotifyStatusNameEnum {
  PENDING_PROCESS = 'บันทึกแบบร่าง',
  PENDING_TRANSACTION = 'รอพิจารณาจัดซื้อ',
  PURCHASE_REVIEWED = 'พิจารณาจัดซื้อแล้ว',
  REQUEST_CANCELED = 'ยกเลิก',
  PENDING_PURCHASE_REVIEW = 'บันทึกแบบร่าง พด.1',
  PENDING_PURCHASE_APPROVAL = 'รอผ่านรายการ',
  RETURN_FOR_EDIT = 'ไม่ผ่าน',
  PENDING_DIRECTOR_APPROVAL = 'รออนุมัติ',
  FINAL_PURCHASE_APPROVED = 'อนุมัติจัดซื้อแล้ว',
  NO_STATUS = '-',
}

// แจ้งความต้องการ
export enum NotifyHistoryStatusNameEnum {
  PENDING_TRANSACTION = 'บันทึกแบบร่าง',
  REQUEST_CANCELED = 'ยกเลิก',
  PENDING_PURCHASE_REVIEW = 'รอพิจารณาจัดซื้อ',
  PENDING_PURCHASE_APPROVAL = 'พิจารณาจัดซื้อ',
  FINAL_PURCHASE_APPROVED = 'จัดซื้อแล้ว',
}
// แจ้งความต้องการ
export enum NotifyStatusEnum {
  GENERAL_DRAFT = 0,
  GENERAL_CONFIRMED = 1,
  GENERAL_CANCELED = 90,
  PROCUREMENT_DRAFT = 2,
  PROCUREMENT_CONFIRMED = 3,
  PROCUREMENT_REJECTED = 91,
  PROCUREMENT_MANAGER_APPROVED = 4,
  DIRECTOR_REJECTED = 92,
  DIRECTOR_APPROVED = 5,
}

export enum stateApproveEnum {
  MaterialManagerApprove = 1,
  Reject = 2,
  DirectorApprove = 3,
}
